<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <canal-cobro-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import CanalCobroProvider from "../../../../providers/CanalCobroProvider";
    
    import {CrudUpdate, ClientError} from '@dracul/common-frontend'
    
    import CanalCobroForm from "../CanalCobroForm";
  
    

    export default {
        name: "CanalCobroUpdate",
        
        components: { CanalCobroForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'cobrox.canalCobro.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                id: this.item.id,
                form: {
                    nombre: this.item.nombre,
                    cuentaDestinoDefault: this.item.cuentaDestinoDefault ? this.item.cuentaDestinoDefault.id : null,
                    tipoCanal: this.item.tipoCanal,
                    visiblePorAgencia: this.item.visiblePorAgencia
                }
            }
        },
        methods: {
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    CanalCobroProvider.updateCanalCobro(this.id, this.form).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.updateCanalCobro)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>

